export default class SchibstedAccountSessionHandler {
    constructor(identity, clientActions) {
        this.identity = identity;
        this.clientActions = clientActions;
    }
    static isHasSessionFailureResponse(response) {
        return response.error !== undefined;
    }
    refreshSpidSession() {
        this.identity
            .hasSession(false)
            .then((response) => {
            // Log success or failure.
            if (SchibstedAccountSessionHandler.isHasSessionFailureResponse(response)) {
                this.clientActions.track('FailureResponse');
            }
            else {
                this.clientActions.track('SuccessResponse');
            }
        })
            .catch((exception) => {
            // This error is so common it spams trackjs, ignore it
            if (exception.message !== 'HasSession failed') {
                console.error(exception);
            }
            this.clientActions.track('ErrorResponse');
        });
    }
}
//# sourceMappingURL=schibsted-account-session-handler.js.map